/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
export interface AddressApiContract {
  /** @nullable */
  StreetAddress1?: string | null;
  /** @nullable */
  StreetAddress2?: string | null;
  /** @nullable */
  City?: string | null;
  /** @nullable */
  Zip?: string | null;
  /**
   * 2 digits
   * @nullable
   */
  StateCode?: string | null;
  /**
   * 2 digits
   * @nullable
   */
  CountryCode?: string | null;
}

/**
 * @nullable
 */
export type ApplicationSettingsDoctorApiOutContractAsynchronousVisitsSettings = AsynchronousVisitsSettingsDoctorApiOutContract | null;

export interface ApplicationSettingsDoctorApiOutContract {
  /** @nullable */
  SettingsPerState?: ApplicationSettingsPerStateDoctorApiOutContract[] | null;
  /** @nullable */
  AsynchronousVisitsSettings?: ApplicationSettingsDoctorApiOutContractAsynchronousVisitsSettings;
}

export interface ApplicationSettingsPerStateDoctorApiOutContract {
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  DrugScreenHtml?: string | null;
}

export interface AsynchronousVisitsSettingsDoctorApiOutContract {
  ClaimTimeoutMinutes?: number;
}

export interface AuthTokenApiContract {
  /** @nullable */
  AccessToken: string | null;
}

export interface AuthTokenPairApiContract {
  /** @nullable */
  AccessToken?: string | null;
  /** @nullable */
  RefreshToken?: string | null;
}

export interface AuthorApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
}

export interface AuthorWithTypeApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  UserType?: string | null;
}

export interface ChangeDoctorCalendarOccurrencesStaffApiInContract {
  /**
   * Collection of occurrences to create.
   * @nullable
   */
  Create?: CreateDoctorCalendarOccurrenceStaffApiInContract[] | null;
  /**
   * Collection of occurrences to edit.
   * @nullable
   */
  Edit?: EditDoctorCalendarOccurrenceStaffApiInContract[] | null;
  /**
   * Collection of occurrence ids to delete.
   * @nullable
   */
  Delete?: string[] | null;
}

export interface ChangeDoctorCalendarSchedulesStaffApiInContract {
  /**
   * Collection of schedules to create.
   * @nullable
   */
  Create?: CreateDoctorCalendarScheduleStaffApiInContract[] | null;
  /**
   * Collection of schedules to edit.
   * @nullable
   */
  Edit?: EditDoctorCalendarScheduleStaffApiInContract[] | null;
  /**
   * Collection of schedule ids to delete.
   * @nullable
   */
  Delete?: string[] | null;
}

/**
 * @nullable
 */
export type ChangeDoctorCalendarStaffApiInContractSchedules = ChangeDoctorCalendarSchedulesStaffApiInContract | null;

/**
 * @nullable
 */
export type ChangeDoctorCalendarStaffApiInContractOccurrences = ChangeDoctorCalendarOccurrencesStaffApiInContract | null;

export interface ChangeDoctorCalendarStaffApiInContract {
  /** Required, Valid value in IANA or Windows format */
  TimeZone: string;
  /** @nullable */
  Schedules?: ChangeDoctorCalendarStaffApiInContractSchedules;
  /** @nullable */
  Occurrences?: ChangeDoctorCalendarStaffApiInContractOccurrences;
}

export interface ChangePasswordApiInContract {
  /** @nullable */
  CurrentPassword?: string | null;
  /** @nullable */
  NewPassword?: string | null;
}

export interface ConfirmShipmentDoctorApiInContract {
  /** Identifies the label the pharmacist just printed (returned by the label endpoint). The server
loads its own persisted shipment record by this id — it does not trust client-supplied tracking,
carrier, cost, or ZPL, all of which are already owned server-side from the label step. */
  LabelThirdPartyKey: string;
}

export interface ConfirmShipmentDoctorApiOutContract {
  Success: boolean;
}

export interface CounterSummaryApiContract {
  Count?: number;
}

export interface CreateDoctorCalendarOccurrenceStaffApiInContract {
  Type: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /**
   * Global key of the treatment center for an in-person block. If null, the block has no treatment center
(and inherits the parent schedule's treatment center when it belongs to one).
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface CreateDoctorCalendarScheduleStaffApiInContract {
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /** Recurrence settings for the schedule. */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional global key of the treatment center to associate with this schedule.
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

/**
 * @nullable
 */
export type CreateShippingLabelDoctorApiInContractShipToAddressOverride = ShipToAddressOverrideStaffApiInContract | null;

export interface CreateShippingLabelDoctorApiInContract {
  RateId: string;
  /** @nullable */
  ShipToAddressOverride?: CreateShippingLabelDoctorApiInContractShipToAddressOverride;
  /**
   * Global keys of the order items to include in this shipment. When null or empty, all order items are included.
   * @nullable
   */
  OrderItemIds?: string[] | null;
}

export interface CreateShippingLabelDoctorApiOutContract {
  TrackingNumber: string;
  /** @nullable */
  TrackingUrl?: string | null;
  Carrier: string;
  ServiceType: string;
  ShippingCost: number;
  LabelThirdPartyKey: string;
  ShipmentThirdPartyKey: string;
  /** ZPL for the shipping label. The pharmacist's browser prints this to the local Zebra
printer via Zebra Browser Print; it is also echoed back on shipment confirmation. */
  LabelZpl: string;
}

export interface CreateVisitPrescriptionItemDoctorApiInContract {
  ProductId: string;
  OptionId: string;
  /** @nullable */
  RefillsQuantity?: number | null;
  IsSubstitutionAllowed?: boolean;
  Signature: string;
  /** @nullable */
  DrugOptionId?: string | null;
  DurationDays?: number;
}

/**
 * @nullable
 */
export type CreateVisitPrescriptionItemDoctorApiOutContractFulfillmentType = OutProductFulfillmentType | null;

export interface CreateVisitPrescriptionItemDoctorApiOutContract {
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Brand: string | null;
  /** @nullable */
  DrugName: string | null;
  Quantity: number;
  /** @nullable */
  Dosage: string | null;
  /** @nullable */
  Frequency: string | null;
  DispenseAmount: number;
  /** @nullable */
  DispenseUnits: string | null;
  DurationDays: number;
  /** @nullable */
  Signature: string | null;
  /** @nullable */
  PharmacyPartner: string | null;
  /** @nullable */
  FulfillmentType: CreateVisitPrescriptionItemDoctorApiOutContractFulfillmentType;
}

/**
 * @nullable
 */
export type CreateVisitPrescriptionsDoctorApiInContractAddress = AddressApiContract | null;

export interface CreateVisitPrescriptionsDoctorApiInContract {
  /** @nullable */
  Note?: string | null;
  /** @nullable */
  PharmacyNcpdpId?: string | null;
  /** @nullable */
  EarliestFillDate?: string | null;
  Items: CreateVisitPrescriptionItemDoctorApiInContract[];
  /** @nullable */
  Address?: CreateVisitPrescriptionsDoctorApiInContractAddress;
}

/**
 * @nullable
 */
export type CreateVisitPrescriptionsDoctorApiOutContractProvider = DoctorApiOutContract | null;

export interface CreateVisitPrescriptionsDoctorApiOutContract {
  /** @nullable */
  EncounterUrl: string | null;
  /** @nullable */
  Items: CreateVisitPrescriptionItemDoctorApiOutContract[] | null;
  /** @nullable */
  Provider: CreateVisitPrescriptionsDoctorApiOutContractProvider;
}

export interface DoctorApiOutContract {
  /** @nullable */
  ProviderId?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
}

/**
 * VisitTypeGroup that limits available VisitTypes for booking for the given schedule. null means all licensed VisitTypes available for booking
 * @nullable
 */
export type DoctorCalendarScheduleApiStaffOutContractVisitTypeGroup = ScheduleVisitTypeGroupStaffApiOutContract | null;

/**
 * Optional treatment center tied to availability block
 * @nullable
 */
export type DoctorCalendarScheduleApiStaffOutContractTreatmentCenter = TreatmentCenterApiOutContract | null;

export interface DoctorCalendarScheduleApiStaffOutContract {
  ScheduleId: string;
  /** Windows id of timezone schedule was created on */
  TimeZone: string;
  /** Date and time when schedule starts */
  FromDateTime: string;
  /** Date and time when schedule ends */
  ToDateTime: string;
  /** Collection of 2 letter USA state codes the schedule is overridden for. Field has value only if whole schedule is overridden for certain state(s). */
  StateCodes: string[];
  /**
   * VisitTypeGroup that limits available VisitTypes for booking for the given schedule. null means all licensed VisitTypes available for booking
   * @nullable
   */
  VisitTypeGroup?: DoctorCalendarScheduleApiStaffOutContractVisitTypeGroup;
  /** Recurring settings of schedule */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional treatment center tied to availability block
   * @nullable
   */
  TreatmentCenter?: DoctorCalendarScheduleApiStaffOutContractTreatmentCenter;
}

export interface DoctorCalendarScheduleRecurringSettingsStaffApiContract {
  /** Required. Can contain [monday, tuesday, wednesday, thursday, friday, saturday, sunday] */
  WeekDays: string[];
  /**
   * End date of recurring
   * @nullable
   */
  EndDateTime?: string | null;
}

export interface EditDoctorCalendarOccurrenceStaffApiInContract {
  OccurrenceId?: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime?: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime?: string;
  /** List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override */
  StateCodes?: string[];
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /**
   * Global key of the treatment center for an in-person block. If null, the block has no treatment center
(and inherits the parent schedule's treatment center when it belongs to one).
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface EditDoctorCalendarScheduleStaffApiInContract {
  ScheduleId: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /** Recurrence settings for the schedule. */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional global key of the treatment center to associate with this schedule.
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface EmailApiContract {
  /** @nullable */
  Email?: string | null;
}

export interface EncounterUrlDoctorApiOutContract {
  /** @nullable */
  ProfileUrl: string | null;
}

export interface ErrorApiOutContract {
  /** @nullable */
  ErrorCode?: string | null;
}

export interface ErrorDescription {
  StatusCode?: HttpStatusCode;
  /** @nullable */
  ErrorCode?: string | null;
}

/**
 * @nullable
 */
export type ExecutionResultResponseHeaders = {[key: string]: string} | null;

export interface ExecutionResult {
  StatusCode?: HttpStatusCode;
  ErrorCode?: string;
  Data?: unknown;
  /** @nullable */
  ResponseHeaders?: ExecutionResultResponseHeaders;
}

export interface FormulationApiContract {
  Price: number;
  TotalQuantity: number;
}

export interface FulfillmentPartnerStaffApiOutContract {
  Name: string;
  NcpdpId: string;
  ExcludedStateCodes: string[];
  ShippingOptions: ShippingOptionStaffApiOutContract[];
}

/**
 * VisitTypeGroup that limits available VisitTypes for booking for the given occurrence. null means all licensed VisitTypes available for booking
 * @nullable
 */
export type GetDoctorCalendarOccurrenceItemStaffApiOutContractVisitTypeGroup = ScheduleVisitTypeGroupStaffApiOutContract | null;

/**
 * Optional treatment center tied to this availability block
 * @nullable
 */
export type GetDoctorCalendarOccurrenceItemStaffApiOutContractTreatmentCenter = TreatmentCenterApiOutContract | null;

export interface GetDoctorCalendarOccurrenceItemStaffApiOutContract {
  /** Unique identity of occurrence */
  OccurrenceId?: string;
  /**
   * Unique identity of recurring schedule. null for one-time occurrences
   * @nullable
   */
  ScheduleId?: string | null;
  /**
   * Ordered number of occurrence in a scope of schedule (starting with 0). Can be used by client side in case when need to understand is it first occurrence in schedule. null for one-time occurrences
   * @nullable
   */
  ScheduleOrderNumber?: number | null;
  /** Date and time when range starts */
  FromDateTime?: string;
  /** Date and time when range ends */
  ToDateTime?: string;
  /** Collection of 2 letter USA state codes the schedule occurrence is set for. Value is historical for the past. Can be empty if provider has no licenses */
  StateCodes?: string[];
  /**
   * VisitTypeGroup that limits available VisitTypes for booking for the given occurrence. null means all licensed VisitTypes available for booking
   * @nullable
   */
  VisitTypeGroup?: GetDoctorCalendarOccurrenceItemStaffApiOutContractVisitTypeGroup;
  /**
   * Optional treatment center tied to this availability block
   * @nullable
   */
  TreatmentCenter?: GetDoctorCalendarOccurrenceItemStaffApiOutContractTreatmentCenter;
}

export interface GetDoctorCalendarOccurrenceItemStaffApiOutContractGetDoctorCalendarStaffApiOutContract {
  /** @nullable */
  Availability?: GetDoctorCalendarOccurrenceItemStaffApiOutContract[] | null;
  /** @nullable */
  Unavailability?: GetDoctorCalendarOccurrenceItemStaffApiOutContract[] | null;
  /** @nullable */
  Visits?: GetDoctorCalendarVisitItemStaffApiOutContract[] | null;
}

export interface GetDoctorCalendarVisitItemStaffApiOutContract {
  /** @nullable */
  VisitId?: string | null;
  /** @nullable */
  FromDateTime?: string | null;
  /** @nullable */
  ToDateTime?: string | null;
  /** @nullable */
  PatientFirstName?: string | null;
  /** @nullable */
  PatientLastName?: string | null;
  IsNewPatientVisit?: boolean;
}

/**
 * @nullable
 */
export type GetShippingRatesDoctorApiInContractShipToAddressOverride = ShipToAddressOverrideStaffApiInContract | null;

export interface GetShippingRatesDoctorApiInContract {
  /** @nullable */
  WeightOunces?: number | null;
  /** @nullable */
  LengthInches?: number | null;
  /** @nullable */
  WidthInches?: number | null;
  /** @nullable */
  HeightInches?: number | null;
  /** @nullable */
  ShipToAddressOverride?: GetShippingRatesDoctorApiInContractShipToAddressOverride;
  /**
   * Global keys of the order items the shipment will cover. When null or empty the whole order is assumed.
Pass the same items you will pass to create-label: a previous label may have overridden the ship-to
address for a subset of items, so quoting against the whole order can price the wrong destination.
   * @nullable
   */
  OrderItemIds?: string[] | null;
  /** When true, requests signature confirmation on delivery (adds a surcharge to the rate). Pre-check it from the order
detail's SignatureRequired; the pharmacist may opt out. */
  SignatureRequired?: boolean;
}

export interface GetShippingRatesDoctorApiOutContract {
  Rates: ShippingRateDoctorApiOutContract[];
  DestinationAddress: string;
}

/**
 * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
 */
export interface GrantProgramVisitCoverageApiOutContract {
  /** @nullable */
  Name?: string | null;
}

export type HttpStatusCode = typeof HttpStatusCode[keyof typeof HttpStatusCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HttpStatusCode = {
  NUMBER_100: 100,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_103: 103,
  NUMBER_200: 200,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_203: 203,
  NUMBER_204: 204,
  NUMBER_205: 205,
  NUMBER_206: 206,
  NUMBER_207: 207,
  NUMBER_208: 208,
  NUMBER_226: 226,
  NUMBER_300: 300,
  NUMBER_301: 301,
  NUMBER_302: 302,
  NUMBER_303: 303,
  NUMBER_304: 304,
  NUMBER_305: 305,
  NUMBER_306: 306,
  NUMBER_307: 307,
  NUMBER_308: 308,
  NUMBER_400: 400,
  NUMBER_401: 401,
  NUMBER_402: 402,
  NUMBER_403: 403,
  NUMBER_404: 404,
  NUMBER_405: 405,
  NUMBER_406: 406,
  NUMBER_407: 407,
  NUMBER_408: 408,
  NUMBER_409: 409,
  NUMBER_410: 410,
  NUMBER_411: 411,
  NUMBER_412: 412,
  NUMBER_413: 413,
  NUMBER_414: 414,
  NUMBER_415: 415,
  NUMBER_416: 416,
  NUMBER_417: 417,
  NUMBER_421: 421,
  NUMBER_422: 422,
  NUMBER_423: 423,
  NUMBER_424: 424,
  NUMBER_426: 426,
  NUMBER_428: 428,
  NUMBER_429: 429,
  NUMBER_431: 431,
  NUMBER_451: 451,
  NUMBER_500: 500,
  NUMBER_501: 501,
  NUMBER_502: 502,
  NUMBER_503: 503,
  NUMBER_504: 504,
  NUMBER_505: 505,
  NUMBER_506: 506,
  NUMBER_507: 507,
  NUMBER_508: 508,
  NUMBER_510: 510,
  NUMBER_511: 511,
} as const;

export interface IcdCodeStaffApiOutContract {
  /** @nullable */
  IcdCodeId?: string | null;
  /** @nullable */
  Code?: string | null;
  /** @nullable */
  Description?: string | null;
}

export type InPersonComplianceStatusOutContract = typeof InPersonComplianceStatusOutContract[keyof typeof InPersonComplianceStatusOutContract];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InPersonComplianceStatusOutContract = {
  none: 'none',
  compliant: 'compliant',
  soon: 'soon',
  overdue: 'overdue',
} as const;

export interface IntakeFormListItemStaffApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
}

export interface IntakeFormStaffApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
}

export interface IterableTokenApiOutContract {
  /** @nullable */
  AccessToken: string | null;
  ExpiresAtUtc: string;
}

/**
 * @nullable
 */
export type MagicLinkLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface MagicLinkLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  ClientInfo?: MagicLinkLoginWebApiInContractClientInfo;
}

export interface MediaFileDrugScreenStaffApiInContract {
  /** @nullable */
  CompleteDate?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
}

export interface MediaFileDrugScreenStaffApiOutContract {
  /** @nullable */
  CompleteDate?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
  /** @nullable */
  Status?: string | null;
}

/**
 * @nullable
 */
export type MediaFileStaffApiOutContractDrugScreen = MediaFileDrugScreenStaffApiOutContract | null;

/**
 * @nullable
 */
export type MediaFileStaffApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface MediaFileStaffApiOutContract {
  /** @nullable */
  FileName?: string | null;
  /** @nullable */
  Url?: string | null;
  /** @nullable */
  UploadDateTime?: string | null;
  /** @nullable */
  FileId?: string | null;
  /** @nullable */
  Tags?: string[] | null;
  /** @nullable */
  DrugScreen?: MediaFileStaffApiOutContractDrugScreen;
  /** @nullable */
  Author?: MediaFileStaffApiOutContractAuthor;
}

export interface MedicationStaffApiOutContract {
  Id: string;
  Name: string;
  /** @nullable */
  NationalDrugCode: string | null;
  /** @nullable */
  GenericCodeNumber: string | null;
  /** @nullable */
  AlternativeThirdPartyKey: string | null;
  IsControlledSubstance: boolean;
  DispenseUnit: string;
  /** Broad classification of service types. Each category can have its own
QuickMD.Constants.LifecycleRuleSet governing lifecycle state transitions. */
  Category: ServiceCategory;
  PatientDescription: string;
  ImageUrl: string;
  Formulations: FormulationApiContract[];
  FulfillmentPartnerNcpdpIds: string[];
}

export interface MergeMetadataStaffApiOutContract {
  IsSecondaryMergedAccount?: boolean;
  /** @nullable */
  MainAccountMedicalRecordNumber?: string | null;
  /** @nullable */
  MainAccountId?: string | null;
  /** @nullable */
  SourceAccountsMetadata?: SourceAccountMetadataOutContractItem[] | null;
}

export interface MessageApiContract {
  /** @nullable */
  Message?: string | null;
}

/**
 * @nullable
 */
export type OauthLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface OauthLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  ClientInfo?: OauthLoginWebApiInContractClientInfo;
}

export interface OrderFulfillmentDetailDoctorApiOutContract {
  OrderId: string;
  OrderNumber: string;
  PatientName: string;
  ShippingAddress: PharmacyOrderShippingAddressDoctorApiOutContract;
  /**
   * The delivery method + business-day window the patient chose, used to buy the shipping label.
   * @nullable
   */
  DeliveryMethod?: string | null;
  /** @nullable */
  DeliveryMinimumBusinessDays?: number | null;
  /** @nullable */
  DeliveryMaximumBusinessDays?: number | null;
  /** True when the caller may re-trigger fulfillment: QuickMD Pharmacy order at the caller's pharmacy that is
`onhold`, or `sent` for 15 minutes or more, and not yet submitted to the pharmacy. */
  CanTriggerFulfillment: boolean;
  /** True when any item in the order should ship with delivery signature confirmation (billed to insurance, or a
controlled substance shipping to a state that requires a signature). A recommendation only: pre-check the
signature option in the UI when this is true; the pharmacist can override it. */
  SignatureRequired: boolean;
  /** True when this order is the patient's first non-cancelled order containing a medication-assisted treatment (MAT) item,
merged accounts included. Later MAT orders and orders without a MAT item are false. */
  IsNewToMatHomeDelivery: boolean;
  Items: OrderFulfillmentItemDoctorApiOutContract[];
}

/**
 * @nullable
 */
export type OrderFulfillmentItemDoctorApiOutContractShipmentStatus = OutShipmentStatus | null;

export interface OrderFulfillmentItemDoctorApiOutContract {
  OrderItemId: string;
  Name: string;
  DrugName: string;
  Quantity: number;
  /** @nullable */
  StoreId: number | null;
  /** @nullable */
  RxNumber: number | null;
  /** @nullable */
  RfNumber: number | null;
  /** @nullable */
  ShipmentStatus: OrderFulfillmentItemDoctorApiOutContractShipmentStatus;
  /** @nullable */
  LabelThirdPartyKey: string | null;
  /** @nullable */
  TrackingUrl: string | null;
  /** @nullable */
  ShippingCost: number | null;
}

export type OutOrderStatus = typeof OutOrderStatus[keyof typeof OutOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutOrderStatus = {
  pendingpayment: 'pendingpayment',
  pendingauthorization: 'pendingauthorization',
  onhold: 'onhold',
  senttopharmacy: 'senttopharmacy',
  confirmed: 'confirmed',
  shipped: 'shipped',
  delivered: 'delivered',
  cancelled: 'cancelled',
} as const;

export type OutPrescriptionStatus = typeof OutPrescriptionStatus[keyof typeof OutPrescriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutPrescriptionStatus = {
  cancel: 'cancel',
  cancel_denied: 'cancel_denied',
  cancel_failed: 'cancel_failed',
  cancel_initiated: 'cancel_initiated',
  cancel_pending: 'cancel_pending',
  cancel_success: 'cancel_success',
  cancel_trans_failed: 'cancel_trans_failed',
  cancelled: 'cancelled',
  pending: 'pending',
  printed: 'printed',
  rx_change_approved_with_changes: 'rx_change_approved_with_changes',
  rx_change_denied: 'rx_change_denied',
  rx_change_failed: 'rx_change_failed',
  rx_change_requested: 'rx_change_requested',
  rx_change_sent: 'rx_change_sent',
  rx_renewal_denied: 'rx_renewal_denied',
  rx_renewal_failed: 'rx_renewal_failed',
  rx_renewal_replace: 'rx_renewal_replace',
  xmit: 'xmit',
  xmit_failed: 'xmit_failed',
} as const;

export type OutProductFulfillmentType = typeof OutProductFulfillmentType[keyof typeof OutProductFulfillmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutProductFulfillmentType = {
  treat: 'treat',
  zendesk: 'zendesk',
} as const;

export type OutShipmentCarrier = typeof OutShipmentCarrier[keyof typeof OutShipmentCarrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutShipmentCarrier = {
  fedex: 'fedex',
  usps: 'usps',
  ups: 'ups',
  other: 'other',
} as const;

export type OutShipmentStatus = typeof OutShipmentStatus[keyof typeof OutShipmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutShipmentStatus = {
  preparing: 'preparing',
  shipped: 'shipped',
  outfordelivery: 'outfordelivery',
  delivered: 'delivered',
  exceptionreported: 'exceptionreported',
  voided: 'voided',
} as const;

/**
 * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
 */
export interface PackageVisitCoverageApiOutContract {
  /** @nullable */
  Name?: string | null;
  /** Visits of this visit type the cover grants in total - the "5" in "Visit 2 of 5". This is the allowance the
patient bought, so changing the package afterwards does not move it. */
  AllowedQuantity?: number;
  /** Visits of this visit type still unspent, as they stand now rather than when this visit was booked. Unlike
Pwrdby.QuickMD.Api.Contracts.Visits.PackageVisitCoverageApiOutContract.Position it keeps changing: later bookings spend from it, and cancelling gives one back. */
  RemainingQuantity?: number;
  /** Which covered visit this one is - the "2" in "Visit 2 of 5". For a booked visit it is counted from the
visits already drawn against the cover, so it is fixed for that visit's life: booking a third does not
renumber the second, and visits cancelled or left unresolved gave theirs back and are not counted. On a
reservation, where no visit exists yet, it is the one about to be booked. */
  Position?: number;
}

/**
 * @nullable
 */
export type PasswordLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface PasswordLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  Password?: string | null;
  /** @nullable */
  ClientInfo?: PasswordLoginWebApiInContractClientInfo;
}

/**
 * @nullable
 */
export type PatientAccountInformationDoctorApiInContractEmergencyContact = PatientEmergencyContactApiContract | null;

export interface PatientAccountInformationDoctorApiInContract {
  /** @nullable */
  PreferredName?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  PharmacyId?: string | null;
  /** @nullable */
  EmergencyContact?: PatientAccountInformationDoctorApiInContractEmergencyContact;
}

export interface PatientAlertStaffApiInContract {
  /** @nullable */
  Message?: string | null;
  IsPrivate?: boolean;
}

/**
 * @nullable
 */
export type PatientAlertStaffApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface PatientAlertStaffApiOutContract {
  /** @nullable */
  AlertId?: string | null;
  /** @nullable */
  Author?: PatientAlertStaffApiOutContractAuthor;
  /** @nullable */
  Message?: string | null;
  IsPrivate?: boolean;
  /** @nullable */
  UpdateDateTime?: string | null;
  IsEditAllowed?: boolean;
  IsRead?: boolean;
}

export interface PatientAlertSummaryStaffApiOutContract {
  Count?: number;
  /** @nullable */
  LastUpdateDateTime?: string | null;
  HasUnread?: boolean;
}

export interface PatientAllergyApiInContract {
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Severity?: string | null;
}

/**
 * @nullable
 */
export type PatientAllergyApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface PatientAllergyApiOutContract {
  /** @nullable */
  AllergyId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Severity?: string | null;
  /** @nullable */
  Author?: PatientAllergyApiOutContractAuthor;
}

export interface PatientAllergyCollectionApiOutContract {
  HasNoAllergyConfirmation?: boolean;
  /** @nullable */
  Allergies?: PatientAllergyApiOutContract[] | null;
}

export interface PatientDoctorCohortsApiOutContract {
  /** @nullable */
  Cohorts: string[] | null;
}

export interface PatientDrugScreenStatusStaffApiOutContract {
  /** @nullable */
  FileId?: string | null;
  /** @nullable */
  CompleteDate?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
  /** @nullable */
  Status?: string | null;
}

/**
 * @nullable
 */
export type PatientEmergencyContactApiContractPhoneNumber = PhoneApiContract | null;

export interface PatientEmergencyContactApiContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Relationship?: string | null;
  /** @nullable */
  IsAuthorized?: boolean | null;
  /** @nullable */
  PhoneNumber?: PatientEmergencyContactApiContractPhoneNumber;
}

export interface PatientGeneralInformationStaffApiInContract {
  /** @nullable */
  HeightInches?: number | null;
  /** @nullable */
  WeightPounds?: number | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  MaritalStatus?: string | null;
  /** @nullable */
  GenderIdentity?: string | null;
  /** @nullable */
  RacialBackground?: string | null;
}

export interface PatientIdentityVerificationDetailsStaffApiOutContract {
  /** @nullable */
  Status?: string | null;
  /** @nullable */
  RequestDateTime?: string | null;
  /** @nullable */
  VerificationId?: string | null;
  /** @nullable */
  Url?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
  /** @nullable */
  PatientPhotoUrl?: string | null;
  /** @nullable */
  IdentityPhotoUrl?: string | null;
  /** @nullable */
  Overrides?: PatientIdentityVerificationDetailsStatusOverrideStaffApiOutContract[] | null;
}

/**
 * @nullable
 */
export type PatientIdentityVerificationDetailsStatusOverrideStaffApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface PatientIdentityVerificationDetailsStatusOverrideStaffApiOutContract {
  /** @nullable */
  Author?: PatientIdentityVerificationDetailsStatusOverrideStaffApiOutContractAuthor;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  CreateDateTime?: string | null;
}

export interface PatientIdentityVerificationStaffApiOutContract {
  /** @nullable */
  Status?: string | null;
  /** @nullable */
  RequestDateTime?: string | null;
}

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractPhoneNumber = PhoneApiContract | null;

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

export interface PatientListItemStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  MedicalRecordNumber?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  LastSeenDateTime?: string | null;
  /** @nullable */
  RestrictionStatus?: string | null;
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
  /** @nullable */
  PhoneNumber?: PatientListItemStaffApiOutContractPhoneNumber;
  /** @nullable */
  IdentityVerification?: PatientListItemStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: PatientListItemStaffApiOutContractDrugScreen;
  /** @nullable */
  NextVisitDateTimeUtc?: string | null;
  HasActiveSubscriptions?: boolean;
  IsMergedMainAccount?: boolean;
}

export interface PatientMessageStaffApiContract {
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  PatientId?: string | null;
}

/**
 * A package the patient bought, as they bought it. Shared by the patient and admin APIs, so the same purchase reads
identically whoever is looking.
 */
export interface PatientPackageApiOutContract {
  /** @nullable */
  Id?: string | null;
  /** @nullable */
  Name?: string | null;
  /**
   * The service the package is sold against, for example Medication-Assisted Treatment.
   * @nullable
   */
  ServiceTypeName?: string | null;
  /** What the patient paid. Repricing the package afterwards does not move it. */
  Price?: number;
  /** Whether the package is still within its validity window. It says nothing about what is left to spend: an
active package can have every visit used, and an expired one can have visits it is now too late to use. */
  IsActive?: boolean;
  /** Whether any covered visit type still has a visit left. Independent of Pwrdby.QuickMD.Api.Contracts.Packages.PatientPackageApiOutContract.IsActive. */
  HasRemainingVisits?: boolean;
  PurchasedDateTimeUtc?: string;
  ValidUntilDateTimeUtc?: string;
  /**
   * Every visit type the package covers, whether or not any of its allowance is left.
   * @nullable
   */
  VisitTypes?: PatientPackageVisitTypeApiOutContract[] | null;
}

/**
 * One visit type a package covers, and how much of that allowance the patient still holds.
 */
export interface PatientPackageVisitTypeApiOutContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
  /** Visits of this type the package currently grants - the "of 6" in "3 of 6". Moves when an admin adjusts. */
  AllowedQuantity?: number;
  /** Visits of this type still unspent. Booking a covered visit takes one; cancelling it gives one back. */
  RemainingQuantity?: number;
  /** Visits of this type bought at purchase. Never changes, so it always shows what was originally purchased. */
  PurchasedQuantity?: number;
}

/**
 * @nullable
 */
export type PatientStaffApiOutContractPhoneNumber = PhoneApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAddress = AddressApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractEmergencyContact = PatientEmergencyContactApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAllergyCollection = PatientAllergyCollectionApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPrescriptionSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractVisitSummary = PatientVisitSummaryStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAlertSummary = PatientAlertSummaryStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractIntakeFormSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractMediaFileSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPrescriptionMonitoringProgram = PrescriptionMonitoringProgramStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractMergeMetadata = MergeMetadataStaffApiOutContract | null;

export interface PatientStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  MedicalRecordNumber?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  PreferredName?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  /** @nullable */
  MaritalStatus?: string | null;
  /** @nullable */
  GenderIdentity?: string | null;
  /** @nullable */
  RacialBackground?: string | null;
  /** @nullable */
  HeightInches?: number | null;
  /** @nullable */
  WeightPounds?: number | null;
  CreditAmount?: number;
  ReferralCreditAmount?: number;
  /** @nullable */
  RestrictionStatus?: string | null;
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
  IsRefillAllowed?: boolean;
  /** @nullable */
  TreatSyncError?: string | null;
  /** @nullable */
  HomeDeliveryInterest?: boolean | null;
  /** @nullable */
  CreateDateTimeUtc?: string | null;
  /** @nullable */
  PhoneNumber?: PatientStaffApiOutContractPhoneNumber;
  /** @nullable */
  Address?: PatientStaffApiOutContractAddress;
  /** @nullable */
  EmergencyContact?: PatientStaffApiOutContractEmergencyContact;
  /** @nullable */
  IdentityVerification?: PatientStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: PatientStaffApiOutContractDrugScreen;
  /** @nullable */
  Pharmacy?: PatientStaffApiOutContractPharmacy;
  /** @nullable */
  AllergyCollection?: PatientStaffApiOutContractAllergyCollection;
  /** @nullable */
  PrescriptionSummary?: PatientStaffApiOutContractPrescriptionSummary;
  /** @nullable */
  VisitSummary?: PatientStaffApiOutContractVisitSummary;
  /** @nullable */
  AlertSummary?: PatientStaffApiOutContractAlertSummary;
  /** @nullable */
  IntakeFormSummary?: PatientStaffApiOutContractIntakeFormSummary;
  /** @nullable */
  MediaFileSummary?: PatientStaffApiOutContractMediaFileSummary;
  /** @nullable */
  PrescriptionMonitoringProgram?: PatientStaffApiOutContractPrescriptionMonitoringProgram;
  /** @nullable */
  AccountInfoUpdateDateTime?: string | null;
  /** @nullable */
  Cohorts?: string[] | null;
  IsMergedMainAccount?: boolean;
  /** @nullable */
  MergeMetadata?: PatientStaffApiOutContractMergeMetadata;
}

/**
 * @nullable
 */
export type PatientVisitListItemStaffApiOutContractProvider = VisitDoctorStaffApiOutContract | null;

export interface PatientVisitListItemStaffApiOutContract {
  VisitId?: string;
  VisitDateTime?: string;
  ServiceTypeName?: string;
  VisitTypeName?: string;
  Method?: string;
  Status?: string;
  TimeZone?: string;
  IsMedicationAssistedTreatment?: boolean;
  /** @nullable */
  Provider?: PatientVisitListItemStaffApiOutContractProvider;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
}

export interface PatientVisitSummaryStaffApiOutContract {
  CountPast?: number;
  CountUpcoming?: number;
}

export interface PaymentCreditCardApiOutContract {
  /** @nullable */
  Id?: string | null;
  /** @nullable */
  Number?: string | null;
  /** @nullable */
  Type?: string | null;
  /** @nullable */
  Expiry?: string | null;
  IsDefault?: boolean;
}

/**
 * @nullable
 */
export type PharmacyApiOutContractAddress = AddressApiContract | null;

export interface PharmacyApiOutContract {
  /** @nullable */
  PharmacyId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  NcpdpId?: string | null;
  /** @nullable */
  Phone?: string | null;
  /** @nullable */
  Address?: PharmacyApiOutContractAddress;
}

/**
 * @nullable
 */
export type PharmacyListItemApiOutContractAddress = AddressApiContract | null;

export interface PharmacyListItemApiOutContract {
  /** @nullable */
  PharmacyId: string | null;
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Phone: string | null;
  IsErxEnabled?: boolean;
  IsEpcsEnabled?: boolean;
  IsRetailStore?: boolean;
  Is24Hrs?: boolean;
  IsMailOrder?: boolean;
  IsSpeciality?: boolean;
  IsLTC?: boolean;
  DistanceMiles?: number;
  /** @nullable */
  Address: PharmacyListItemApiOutContractAddress;
}

export interface PharmacyOrderCollectionDoctorApiOutContract {
  TotalCount: number;
  Items: PharmacyOrderCollectionItemDoctorApiOutContract[];
  TotalOrderCount: number;
  TotalShippingCost: number;
  /** @nullable */
  NextCursor?: string | null;
}

/**
 * @nullable
 */
export type PharmacyOrderCollectionItemDoctorApiOutContractShipmentStatus = OutShipmentStatus | null;

/**
 * @nullable
 */
export type PharmacyOrderCollectionItemDoctorApiOutContractTracking = PharmacyOrderTrackingDoctorApiOutContract | null;

/**
 * @nullable
 */
export type PharmacyOrderCollectionItemDoctorApiOutContractShippingAddress = PharmacyOrderShippingAddressDoctorApiOutContract | null;

export interface PharmacyOrderCollectionItemDoctorApiOutContract {
  PatientId: string;
  PatientMrn: string;
  PatientName: string;
  PrescriberName: string;
  /** @nullable */
  Prescription: string | null;
  RxCreatedDate: string;
  /** @nullable */
  OrderId: string | null;
  /** @nullable */
  OrderItemId: string | null;
  /** @nullable */
  OrderNumber: string | null;
  /** @nullable */
  OrderCreatedDate: string | null;
  /** @nullable */
  ShipmentStatus: PharmacyOrderCollectionItemDoctorApiOutContractShipmentStatus;
  /** @nullable */
  ShipmentStatusDescription: string | null;
  /** @nullable */
  Tracking: PharmacyOrderCollectionItemDoctorApiOutContractTracking;
  /** @nullable */
  ShippingAddress: PharmacyOrderCollectionItemDoctorApiOutContractShippingAddress;
  /** @nullable */
  Cost: number | null;
  /** @nullable */
  ShippingCost: number | null;
  /** @nullable */
  LabelThirdPartyKey: string | null;
  /** True when this row's order is the patient's first non-cancelled order containing a medication-assisted treatment (MAT) item,
merged accounts included. For a row without an order, true when the prescription is MAT and the patient has no such order yet. */
  IsNewToMatHomeDelivery: boolean;
  /** True when this item should ship with delivery signature confirmation: it was billed to insurance, or it is a
controlled substance shipping to a state that requires a signature. A recommendation the pharmacist can
override. */
  SignatureRequired: boolean;
  /** @nullable */
  Pv1Pharmacist?: string | null;
  /** @nullable */
  Pv1Date?: string | null;
  /** @nullable */
  Pv2Pharmacist?: string | null;
  /** @nullable */
  Pv2Date?: string | null;
  /** @nullable */
  ScriptlyStatus?: string | null;
  /** @nullable */
  ScriptlySubstatus?: string | null;
  /** @nullable */
  CashOutDate?: string | null;
  /** True when the caller may re-trigger fulfillment: QuickMD Pharmacy order at the caller's pharmacy that is
`onhold`, or `sent` for 15 minutes or more, and not yet submitted to the pharmacy. */
  CanTriggerFulfillment: boolean;
  /** True when every QuickMD Pharmacy item on the order is linked to a QuickMD Pharmacy (Scriptly) order. */
  IsSubmittedToPharmacy: boolean;
}

export interface PharmacyOrderShippingAddressDoctorApiOutContract {
  Address1: string;
  /** @nullable */
  Address2: string | null;
  City: string;
  StateCode: string;
  Zip: string;
  CountryCode: string;
  FormattedAddress: string;
  /** @nullable */
  DeliveryInstructions?: string | null;
}

export type PharmacyOrderSortBy = typeof PharmacyOrderSortBy[keyof typeof PharmacyOrderSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmacyOrderSortBy = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
} as const;

export interface PharmacyOrderTrackingDoctorApiOutContract {
  /** @nullable */
  Carrier: string | null;
  /** @nullable */
  TrackingNumber: string | null;
  /** @nullable */
  TrackingUrl: string | null;
  /** @nullable */
  Events: ShipmentTrackingEventDoctorApiOutContract[] | null;
}

export interface PhoneApiContract {
  /** @nullable */
  CountryCode?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Number?: string | null;
}

export interface PhoneCallAccessTokenDoctorApiOutContract {
  AccessToken: string;
  RoomUrl: string;
  Platform: string;
  /** @nullable */
  CallerId?: string | null;
}

export interface PrescriptionAuthorApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Designation?: string | null;
}

/**
 * @nullable
 */
export type PrescriptionDoctorApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionDoctorApiOutContractDoctor = PrescriptionAuthorApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionDoctorApiOutContractLastOrder = PrescriptionLastOrderApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionDoctorApiOutContractStatus = OutPrescriptionStatus | null;

export interface PrescriptionDoctorApiOutContract {
  /** @nullable */
  Type?: string | null;
  /** @nullable */
  Platform?: string | null;
  /** @nullable */
  Brand?: string | null;
  /** @nullable */
  DrugName?: string | null;
  DispenseAmount?: number;
  /** @nullable */
  DispenseUnits?: string | null;
  /** @nullable */
  Quantity?: number | null;
  /** @nullable */
  Dosage?: string | null;
  /** @nullable */
  CreatedAt?: string | null;
  /** @nullable */
  Directions?: string | null;
  /** @nullable */
  Frequency?: string | null;
  /** @nullable */
  Duration?: number | null;
  /** @nullable */
  Refills?: number | null;
  /** @nullable */
  Pharmacy?: PrescriptionDoctorApiOutContractPharmacy;
  /** @nullable */
  Doctor?: PrescriptionDoctorApiOutContractDoctor;
  /** @nullable */
  PharmacyPartner?: string | null;
  /** True when the prescription goes to a home-delivery pharmacy; false when it goes to a pickup pharmacy. */
  IsHomeDelivery?: boolean;
  /** @nullable */
  TotalFillsRemaining?: number | null;
  /** @nullable */
  PrescriptionId?: string | null;
  /** @nullable */
  Note?: string | null;
  /** @nullable */
  LastOrder?: PrescriptionDoctorApiOutContractLastOrder;
  /** @nullable */
  Status?: PrescriptionDoctorApiOutContractStatus;
  /**
   * Surescripts error (`{Code}: {Description}`) when the prescription failed to reach the pharmacy; null otherwise.
   * @nullable
   */
  Error?: string | null;
  /** @nullable */
  EncounterUrl?: string | null;
}

/**
 * @nullable
 */
export type PrescriptionLastOrderApiOutContractShippingAddress = AddressApiContract | null;

/**
 * @nullable
 */
export type PrescriptionLastOrderApiOutContractShipment = ShipmentSummaryApiOutContract | null;

export interface PrescriptionLastOrderApiOutContract {
  Status: OutOrderStatus;
  Date: string;
  /** @nullable */
  ShippingAddress?: PrescriptionLastOrderApiOutContractShippingAddress;
  /** @nullable */
  Shipment?: PrescriptionLastOrderApiOutContractShipment;
}

export interface PrescriptionMonitoringProgramOutContract {
  /** @nullable */
  ReportUrl?: string | null;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  Error?: string | null;
}

export interface PrescriptionMonitoringProgramStaffApiOutContract {
  /** @nullable */
  LastSeenDateTimeUtc?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

/**
 * @nullable
 */
export type ProductDoctorApiOutContractPriceRange = ProductPriceRangeDoctorApiOutContract | null;

export interface ProductDoctorApiOutContract {
  /** @nullable */
  ProductId: string | null;
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Brand: string | null;
  /** @nullable */
  Variation: string | null;
  /** @nullable */
  Duration: string | null;
  /** @nullable */
  Restriction: string | null;
  IsPharmacyPickupAllowed: boolean;
  /** @nullable */
  FulfillmentType: string | null;
  /** @nullable */
  PriceRange?: ProductDoctorApiOutContractPriceRange;
  IsProviderOverridesEnabled: boolean;
  IsFulfilledByQuickMD: boolean;
  IsControlledSubstance: boolean;
  /**
   * May be empty
   * @nullable
   */
  Options: ProductOptionDoctorApiOutContract[] | null;
  /** @nullable */
  Cohorts: string[] | null;
}

export interface ProductGroupDoctorApiOutContract {
  /**
   * Category of the product group, e.g., "WeightLoss"
   * @nullable
   */
  Group: string | null;
  IsPharmacyPickupAllowed: boolean;
  /** @nullable */
  Products: ProductDoctorApiOutContract[] | null;
}

export interface ProductOptionDoctorApiOutContract {
  /** @nullable */
  OptionId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  ShortName?: string | null;
  Price?: number;
  /** @nullable */
  DurationDisplay?: string | null;
  /** @nullable */
  Signature?: string | null;
  DurationDays?: number;
  /** @deprecated */
  IsRefillAllowed?: boolean;
  /** @nullable */
  PharmacyPartner?: string | null;
  /** @nullable */
  DispenseUnits?: string | null;
  /** @nullable */
  DrugOptions?: ProductOptionDrugOptionDoctorApiOutContract[] | null;
}

export interface ProductOptionDrugOptionDoctorApiOutContract {
  /** @nullable */
  DrugOptionId?: string | null;
  /** @nullable */
  DrugOption?: string | null;
  Quantity?: number;
}

export interface ProductPriceRangeDoctorApiOutContract {
  From?: number;
  To?: number;
}

/**
 * @nullable
 */
export type ProfileDoctorApiInContractPhoneNumber = PhoneApiContract | null;

export interface ProfileDoctorApiInContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  ProfessionalTitles?: string[] | null;
  /** @nullable */
  TimeZone?: string | null;
  /** @nullable */
  PhoneNumber?: ProfileDoctorApiInContractPhoneNumber;
}

/**
 * @nullable
 */
export type ProfileDoctorApiOutContractPhoneNumber = PhoneApiContract | null;

export interface ProfileDoctorApiOutContract {
  ProviderId: string;
  FirstName: string;
  LastName: string;
  Prefix: string;
  Suffix: string;
  Email: string;
  /** @nullable */
  ImageUrl: string | null;
  ProfessionalTitles: string[];
  TimeZone: string;
  /** @nullable */
  PhoneNumber: ProfileDoctorApiOutContractPhoneNumber;
  Licenses: ProfileLicenseDoctorApiOutContract[];
  Cohorts: string[];
  Settings: ProfileSettingsDoctorApiContract;
  Roles: string[];
}

export interface ProfileLicenseDoctorApiOutContract {
  /** @nullable */
  Number?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  DeaNumber?: string | null;
  /** @nullable */
  DeaStateCode?: string | null;
  /** @nullable */
  CslNumber?: string | null;
  /** @nullable */
  VisitTypes?: ProfileVisitTypeDoctorApiOutContract[] | null;
}

export interface ProfileSettingsDoctorApiContract {
  IsNotificationUpcomingShiftAllowed: boolean;
  IsNotificationPatientEnteredWaitingRoomAllowed: boolean;
  IsNotificationEndedVisitReminderAllowed: boolean;
  IsLastMinuteBookingReminderAllowed: boolean;
}

export interface ProfileVisitTypeDoctorApiOutContract {
  VisitTypeId: string;
  Name: string;
  VisibilityOverride: string;
  BaseVisibility: string;
  IsAsynchronous: boolean;
  TreatmentCenters: TreatmentCenterApiOutContract[];
}

export interface QuestionnaireAnswerApiOutContract {
  /** @nullable */
  Question?: string | null;
  /** @nullable */
  Answer?: string | null;
}

export interface QuestionnaireSessionApiOutContract {
  /** @nullable */
  QuestionnaireSessionId?: string | null;
  IsCompleted?: boolean;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  Answers?: QuestionnaireAnswerApiOutContract[] | null;
}

export interface QuestionnaireSessionListItemStaffApiOutContract {
  /** @nullable */
  QuestionnaireSessionId?: string | null;
  /** @nullable */
  QuestionnaireKey?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
}

export interface QuestionnaireStaffApiOutContract {
  /** @nullable */
  QuestionnaireSessionId?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
}

export interface ScheduleVisitTypeGroupStaffApiOutContract {
  VisitTypeGroupId: string;
  Name: string;
  /** @nullable */
  Description?: string | null;
  /** @nullable */
  Abbreviation?: string | null;
  /** The default VisitTypeGroup is applied to all occurrences that do not have a specific VisitTypeGroup assigned. */
  IsDefault: boolean;
}

/**
 * Broad classification of service types. Each category can have its own
QuickMD.Constants.LifecycleRuleSet governing lifecycle state transitions.
 */
export type ServiceCategory = typeof ServiceCategory[keyof typeof ServiceCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceCategory = {
  WeightLoss: 'WeightLoss',
  MedicationAssistedTreatment: 'MedicationAssistedTreatment',
  MenopauseHormoneTherapy: 'MenopauseHormoneTherapy',
  MentalHealth: 'MentalHealth',
} as const;

export interface ServiceTypeListItemDoctorApiOutContract {
  /** @nullable */
  ServiceTypeId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Abbreviation?: string | null;
  Position?: number;
  /** @nullable */
  VisitTypes?: VisitTypeListItemDoctorApiOutContract[] | null;
}

export interface ShipToAddressOverrideStaffApiInContract {
  Address1: string;
  /** @nullable */
  Address2?: string | null;
  City: string;
  Zip: string;
  /** @nullable */
  DeliveryInstructions?: string | null;
}

export interface ShipmentSummaryApiOutContract {
  ShipmentId?: string;
  TrackingNumber?: string;
  Carrier?: OutShipmentCarrier;
  Status?: OutShipmentStatus;
  ShippedDate?: string;
  /** @nullable */
  EstimatedDeliveryDate?: string | null;
  /** @nullable */
  TrackingUrl?: string | null;
}

export interface ShipmentTrackingEventDoctorApiOutContract {
  Status: string;
  EventDateTimeUtc: string;
  EventCode: string;
  EventDescription: string;
}

export interface ShippingOptionStaffApiOutContract {
  Name: string;
  Price: number;
  MinimumDays: number;
  MaximumDays: number;
}

export interface ShippingRateDoctorApiOutContract {
  RateId: string;
  Carrier: string;
  ServiceCode: string;
  ServiceName: string;
  /** @nullable */
  EstimatedDays?: number | null;
  ShippingCost: number;
  IsRecommended: boolean;
  PostageAmount?: number;
  InsuranceAmount?: number;
  ConfirmationAmount?: number;
  OtherAmount?: number;
}

export interface SourceAccountMetadataOutContractItem {
  MedicalRecordNumber: string;
  Id: string;
}

export interface TokenWithPasswordApiContract {
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  Password?: string | null;
}

export interface TreatmentCenterApiOutContract {
  TreatmentCenterId: string;
  Name: string;
  StreetAddress1: string;
  /** @nullable */
  StreetAddress2?: string | null;
  City: string;
  StateCode: string;
  PostalCode: string;
  Country: string;
  PhoneNumber: string;
  IsTemporary?: boolean;
  IsActive?: boolean;
}

/**
 * @nullable
 */
export type UpdateMediaFileStaffApiInContractDrugScreen = MediaFileDrugScreenStaffApiInContract | null;

export interface UpdateMediaFileStaffApiInContract {
  /** @nullable */
  Tags?: string[] | null;
  /** @nullable */
  DrugScreen?: UpdateMediaFileStaffApiInContractDrugScreen;
}

/**
 * Set when a package the patient owns paid for this visit.
 * @nullable
 */
export type VisitCollectionItemDoctorApiOutContractCoverage = VisitCoverageApiOutContract | null;

/**
 * @nullable
 */
export type VisitCollectionItemDoctorApiOutContractPatient = VisitPatientCollectionItemStaffApiOutContract | null;

export interface VisitCollectionItemDoctorApiOutContract {
  /** @nullable */
  VisitId?: string | null;
  /**
   * Set when a package the patient owns paid for this visit.
   * @nullable
   */
  Coverage?: VisitCollectionItemDoctorApiOutContractCoverage;
  /** @nullable */
  VisitNumber?: string | null;
  /** @nullable */
  VisitDateTime?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
  /** @nullable */
  Method?: string | null;
  /** @nullable */
  Status?: string | null;
  IsNewForPatient?: boolean;
  IsNewForServiceType?: boolean;
  IsNewPatientVisit?: boolean;
  /** @nullable */
  Patient?: VisitCollectionItemDoctorApiOutContractPatient;
}

export interface VisitCollectionItemDoctorApiOutContractPaginationItemCollectionApiOutContract {
  /** @nullable */
  Items?: VisitCollectionItemDoctorApiOutContract[] | null;
  TotalCount?: number;
}

/**
 * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
 * @nullable
 */
export type VisitCoverageApiOutContractPackage = PackageVisitCoverageApiOutContract | null;

/**
 * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
 * @nullable
 */
export type VisitCoverageApiOutContractGrantProgram = GrantProgramVisitCoverageApiOutContract | null;

/**
 * What is covering a visit - a package the patient bought, or a grant program funding it. At most one applies;
the other is null, and the whole object is null when nothing covers the visit. Shared by the patient, provider
and admin APIs - the same visit reads identically whoever is looking.
 */
export interface VisitCoverageApiOutContract {
  /**
   * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
   * @nullable
   */
  Package?: VisitCoverageApiOutContractPackage;
  /**
   * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
   * @nullable
   */
  GrantProgram?: VisitCoverageApiOutContractGrantProgram;
}

export interface VisitCurrentMedicationStaffApiOutContract {
  DrugName: string;
  Dosage: string;
  Frequency: string;
}

/**
 * @nullable
 */
export type VisitDoctorApiOutContractIntakeForm = IntakeFormStaffApiOutContract | null;

/**
 * @nullable
 */
export type VisitDoctorApiOutContractPreviousVisit = VisitDoctorApiOutContract | null;

export interface VisitDoctorApiOutContract {
  VisitId?: string;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
  PatientId?: string;
  /** @nullable */
  ProviderId?: string | null;
  ServiceTypeCategory?: string;
  ServiceTypeName?: string;
  VisitTypeName?: string;
  Method?: string;
  Status?: string;
  FromDateTime?: string;
  ToDateTime?: string;
  StateCode?: string;
  Price?: number;
  IsPatientAvailable?: boolean;
  IsNewForPatient?: boolean;
  IsNewForServiceType?: boolean;
  IsNewPatientVisit?: boolean;
  IsMedicationAssistedTreatment?: boolean;
  IsRefillAllowed?: boolean;
  AvailableCreditAmount: number;
  Notes?: VisitMedicalRecordApiOutContract[];
  PatientInstructions?: VisitMedicalRecordApiOutContract[];
  IcdCodes?: IcdCodeStaffApiOutContract[];
  HasRating?: boolean;
  /** @nullable */
  IntakeForm?: VisitDoctorApiOutContractIntakeForm;
  Questionnaires?: QuestionnaireStaffApiOutContract[];
  /** @nullable */
  PreviousVisit?: VisitDoctorApiOutContractPreviousVisit;
  PreviousProviderVisitNotes?: VisitMedicalRecordApiOutContract[];
}

export interface VisitDoctorStaffApiOutContract {
  /** @nullable */
  ProviderId?: string | null;
  FirstName?: string;
  LastName?: string;
  Prefix?: string;
  Suffix?: string;
}

export interface VisitIcdCodeCollectionDoctorApiInContract {
  /** @nullable */
  IcdCodeIds?: string[] | null;
}

/**
 * @nullable
 */
export type VisitMedicalRecordApiOutContractAuthor = AuthorApiOutContract | null;

export interface VisitMedicalRecordApiOutContract {
  /**
   * Identifier of the note or patient instruction, used by the admin endpoints that delete a single record. Null where the endpoint does not load it.
   * @nullable
   */
  Id?: string | null;
  /** @nullable */
  Message?: string | null;
  IsAddendum?: boolean;
  /** @nullable */
  DateTime?: string | null;
  /** @nullable */
  Author?: VisitMedicalRecordApiOutContractAuthor;
}

/**
 * @nullable
 */
export type VisitPatientCollectionItemStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type VisitPatientCollectionItemStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

export interface VisitPatientCollectionItemStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  IdentityVerification?: VisitPatientCollectionItemStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: VisitPatientCollectionItemStaffApiOutContractDrugScreen;
}

/**
 * @nullable
 */
export type VisitPatientPreferenceStaffApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
 */
export interface VisitPatientPreferenceStaffApiOutContract {
  /** @nullable */
  Pharmacy?: VisitPatientPreferenceStaffApiOutContractPharmacy;
  CurrentMedication: VisitCurrentMedicationStaffApiOutContract;
}

export interface VisitRatingAdditionalFeedbackApiInContract {
  /** @nullable */
  Question?: string | null;
  /** @nullable */
  Comments?: string | null;
  Score?: number;
}

export interface VisitRatingApiInContract {
  /** @nullable */
  Text?: string | null;
  Score?: number;
  /** @nullable */
  AdditionalFeedback?: VisitRatingAdditionalFeedbackApiInContract[] | null;
}

/**
 * @nullable
 */
export type VisitRemarkStaffApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface VisitRemarkStaffApiOutContract {
  /** @nullable */
  RemarkId?: string | null;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  DateTime?: string | null;
  IsEditAllowed?: boolean;
  IsEdited?: boolean;
  /** @nullable */
  Author?: VisitRemarkStaffApiOutContractAuthor;
}

export interface VisitTypeListItemDoctorApiOutContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  Name?: string | null;
  IsInPerson?: boolean;
}

/**
 * @nullable
 */
export type VisitV2DoctorApiOutContractIntakeForm = IntakeFormStaffApiOutContract | null;

/**
 * @nullable
 */
export type VisitV2DoctorApiOutContractPreviousVisit = VisitV2DoctorApiOutContract | null;

/**
 * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
 * @nullable
 */
export type VisitV2DoctorApiOutContractPatientPreference = VisitPatientPreferenceStaffApiOutContract | null;

export interface VisitV2DoctorApiOutContract {
  VisitId?: string;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
  PatientId?: string;
  /** @nullable */
  ProviderId?: string | null;
  ServiceTypeCategory?: string;
  ServiceTypeName?: string;
  VisitTypeName?: string;
  Method?: string;
  Status?: string;
  FromDateTime?: string;
  ToDateTime?: string;
  StateCode?: string;
  Price?: number;
  IsPatientAvailable?: boolean;
  IsNewForPatient?: boolean;
  IsNewForServiceType?: boolean;
  IsNewPatientVisit?: boolean;
  IsMedicationAssistedTreatment?: boolean;
  IsRefillAllowed?: boolean;
  AvailableCreditAmount: number;
  Notes?: VisitMedicalRecordApiOutContract[];
  PatientInstructions?: VisitMedicalRecordApiOutContract[];
  IcdCodes?: IcdCodeStaffApiOutContract[];
  HasRating?: boolean;
  /** @nullable */
  IntakeForm?: VisitV2DoctorApiOutContractIntakeForm;
  Questionnaires?: QuestionnaireStaffApiOutContract[];
  /** @nullable */
  PreviousVisit?: VisitV2DoctorApiOutContractPreviousVisit;
  PreviousProviderVisitNotes?: VisitMedicalRecordApiOutContract[];
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
  /** True when the patient is on the Snowflake (data warehouse) list of patients who must be told during this visit
that they need an in-person visit afterwards. Always false on Pwrdby.QuickMD.Providers.Api.Contracts.Visits.Details.VisitV2DoctorApiOutContract.PreviousVisit. */
  ShowInPersonVisitRequiredNotice?: boolean;
  SuggestedIcdCodes?: IcdCodeStaffApiOutContract[];
  /** @nullable */
  ProviderFullName?: string | null;
  /**
   * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
   * @nullable
   */
  PatientPreference?: VisitV2DoctorApiOutContractPatientPreference;
}

export interface VisitVideoDoctorApiOutContract {
  /** @nullable */
  VisitVideoCallId: string | null;
  /** @nullable */
  RoomName: string | null;
  /** @nullable */
  RoomUrl: string | null;
  /** @nullable */
  AccessToken: string | null;
  /** @nullable */
  ExpireDateTimeUtc: string | null;
  /** @nullable */
  Platform: string | null;
}

export interface VoidShippingLabelDoctorApiOutContract {
  Success: boolean;
}

/**
 * @nullable
 */
export type WaitingRoomV2VisitListItemDoctorApiOutContractLastCompletedVisit = WaitingRoomVisitListItemLastCompletedVisitInfoDoctorApiOutContract | null;

export interface WaitingRoomV2VisitListItemDoctorApiOutContract {
  VisitId: string;
  Method: string;
  DateTime: string;
  CheckInDateTime: string;
  ServiceTypeName: string;
  VisitTypeName: string;
  StateCode: string;
  Status: string;
  IsPatientAvailable: boolean;
  IsNewForPatient: boolean;
  IsNewForServiceType: boolean;
  IsNewPatientVisit: boolean;
  Patient: WaitingRoomVisitListItemPatientDoctorApiOutContract;
  OccurrenceNumber?: number;
  /** @nullable */
  LastCompletedVisit?: WaitingRoomV2VisitListItemDoctorApiOutContractLastCompletedVisit;
  ServiceTypeAbbreviation: string;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
}

export interface WaitingRoomVisitListItemDoctorApiOutContract {
  VisitId: string;
  Method: string;
  DateTime: string;
  CheckInDateTime: string;
  ServiceTypeName: string;
  VisitTypeName: string;
  StateCode: string;
  Status: string;
  IsPatientAvailable: boolean;
  IsNewForPatient: boolean;
  IsNewForServiceType: boolean;
  IsNewPatientVisit: boolean;
  Patient: WaitingRoomVisitListItemPatientDoctorApiOutContract;
}

/**
 * @nullable
 */
export type WaitingRoomVisitListItemLastCompletedVisitInfoDoctorApiOutContractProvider = DoctorApiOutContract | null;

export interface WaitingRoomVisitListItemLastCompletedVisitInfoDoctorApiOutContract {
  /** @nullable */
  Provider?: WaitingRoomVisitListItemLastCompletedVisitInfoDoctorApiOutContractProvider;
}

/**
 * @nullable
 */
export type WaitingRoomVisitListItemPatientDoctorApiOutContractPhone = PhoneApiContract | null;

/**
 * @nullable
 */
export type WaitingRoomVisitListItemPatientDoctorApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type WaitingRoomVisitListItemPatientDoctorApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

export interface WaitingRoomVisitListItemPatientDoctorApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  PreferredName?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  MedicalRecordNumber?: string | null;
  /** @nullable */
  Phone?: WaitingRoomVisitListItemPatientDoctorApiOutContractPhone;
  /** @nullable */
  IdentityVerification?: WaitingRoomVisitListItemPatientDoctorApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: WaitingRoomVisitListItemPatientDoctorApiOutContractDrugScreen;
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
}

export interface WebClientInfoContract {
  /**
   * Operating System web client is running on
   * @nullable
   */
  OsType?: string | null;
  /**
   * Web Client Type (Chrome, Safari etc)
   * @nullable
   */
  Type?: string | null;
  /**
   * Web client version
   * @nullable
   */
  Version?: string | null;
}

export type GetCalendarParams = {
/**
 * Date and time to load calendar from. Must be encoded to be used in url. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
 */
FromDateTime?: string;
/**
 * toDateTime	Date and time to load calendar to. Must be encoded to be used in url. Must be greater than fromDateTime. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
 */
ToDateTime?: string;
};

export type GetIcdcodesParams = {
SearchValue?: string;
};

export type PostPatientsPatientIdMediafilesBody = {
  file?: Blob;
  drugScreenCompleteDate?: string;
  drugScreenExpireDate?: string;
  tags?: string[];
};

export type GetMedicationsParams = {
/**
 * Optional case-insensitive search term to filter medications.
 */
search?: string;
};

export type GetPatientsParams = {
Count?: number;
Offset?: number;
SearchValue?: string;
BirthDate?: string;
};

export type GetPharmaciesParams = {
PatientId?: string;
Count?: number;
SearchValue?: string;
IsErxEnabled?: boolean;
IsEpcsEnabled?: boolean;
IsRetailStore?: boolean;
Is24Hrs?: boolean;
IsMailOrder?: boolean;
IsSpeciality?: boolean;
IsLTC?: boolean;
};

export type GetPharmacyOrdersParams = {
Cursor?: string;
Count?: number;
SearchValue?: string;
SortBy?: PharmacyOrderSortBy;
ShipmentStatuses?: string[];
Carriers?: string[];
IsPrintQueue?: boolean;
/**
 * When true, only rows whose order staff may re-trigger fulfillment for are returned: QuickMD Pharmacy orders at
the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more, and not yet submitted to the pharmacy.
 */
CanTriggerFulfillment?: boolean;
};

export type GetPharmacyOrdersExportParams = {
Cursor?: string;
Count?: number;
SearchValue?: string;
SortBy?: PharmacyOrderSortBy;
ShipmentStatuses?: string[];
Carriers?: string[];
IsPrintQueue?: boolean;
/**
 * When true, only rows whose order staff may re-trigger fulfillment for are returned: QuickMD Pharmacy orders at
the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more, and not yet submitted to the pharmacy.
 */
CanTriggerFulfillment?: boolean;
};

export type GetPharmaciesV2Params = {
PatientId?: string;
SearchValue?: string;
ZipCode?: string;
};

export type GetProductsParams = {
/**
 * Category of the product group, e.g., "WeightLoss"
 */
Category?: string;
/**
 * 2 Char state code
 */
StateCode?: string;
PatientId?: string;
};

export type PutProfileImageBody = {
  /** The uploaded image file to set as the profile picture. */
  image?: Blob;
};

export type GetVisitsParams = {
FromDateTime?: string;
ToDateTime?: string;
SearchValue?: string;
IsIncludeUpcoming?: boolean;
IsIncludePast?: boolean;
VisitTypeIds?: string[];
Statuses?: string[];
IsNewForPatient?: boolean;
IsNewForServiceType?: boolean;
DrugScreenStatuses?: string[];
IdentityVerificationStatuses?: string[];
Offset?: number;
Count?: number;
};

export type GetVisitsVisitIdV2Params = {
/**
 * Whether to return the most recent matching visit by provider, patient, and visit type
 */
includeMostRecentMatchingVisit?: boolean;
};

export type GetVisitsV2Params = {
FromDateTime?: string;
ToDateTime?: string;
SearchValue?: string;
IsIncludeUpcoming?: boolean;
IsIncludePast?: boolean;
VisitTypeIds?: string[];
Statuses?: string[];
IsNewForPatient?: boolean;
IsNewForServiceType?: boolean;
DrugScreenStatuses?: string[];
IdentityVerificationStatuses?: string[];
Offset?: number;
Count?: number;
};

export type GetVisitsWaitingroomV2Params = {
/**
 * The timezone identifier (e.g., "America/Los_Angeles" or "Pacific Standard Time")
 */
timezone?: string;
};

